import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./DataBuilders/IContentBuilder";
import { UIManager } from "./UIManager";
/**
 * Aplikační cache
 */
export class BrowserCacheManager {
    private static _isLoading: boolean = false;

    public static showLoader(): void {
        if (BrowserCacheManager._isLoading)
            return;
        if (UIManager) {
            UIManager.instance.showBlockingLayer(new UpdateInProgressLayer());
            BrowserCacheManager._isLoading = true;
        }
    }

    public static hideLoader(): void {
        if (BrowserCacheManager._isLoading && UIManager)
            UIManager.instance.hideBlockingLayer();
        BrowserCacheManager._isLoading = false;
    }
}

export class UpdateInProgressLayer implements IContentBuilder {
    private _element: HTMLElement;

    private async _buildLayoutInfo(): Promise<void> {
        if (!this._element) {
            const content = createElement({ classes: "blocking-layer-content" });
            this._element = content;
            const icon = createElement({ classes: "icon ui-sync" });
            const text = createElement({ classes: "sign-blocking-text" });

            Localization.addLocData(text, "GUI-648220"); //Aktualizujeme aplikaci...
            content.appendChild(icon);
            content.appendChild(text);
            this._element = content;
        }
    }

    public async build(): Promise<HTMLElement> {
        await this._buildLayoutInfo();
        return this._element;
    }
}
